import styles from './style.module.scss';
import { Element } from 'react-scroll';
import { src } from '../../../utils/common';
import FadeIn from '../../commonComponents/fadeIn';
import { useState } from 'react';
import classnames from 'classnames';
import ScenarioMultiRow from '../scenario-multi-row';
import { useWebPResourceCompatibleFn } from '../../../hooks/useWebPResource';

const Scenario = ({
  scenarios,
  ElementHook = 'scenario',
  bgColor = '#f8f9fa',
  hoverEffect = '',
}) => {
  const [active, setActive] = useState(-1);
  const webPResourceHandleFn = useWebPResourceCompatibleFn();
  if (scenarios.length < 4) {
    return (
      <Element name={ElementHook}>
        <div className={styles.scenario} style={{ backgroundColor: bgColor }}>
          <div className={styles.title}>应用场景</div>
          <div
            className={styles.scenarioGroup}
            onMouseLeave={() => setActive(-1)}
          >
            <div className={styles.scenarioMiddle}>
              {scenarios.map((item, index) => {
                const isCurShow = index === active && hoverEffect;
                return (
                  <div
                    key={index}
                    className={styles.item}
                    onMouseEnter={() => setActive(index)}
                  >
                    <div
                      style={{
                        backgroundImage: `url(${webPResourceHandleFn(
                          src(item.picUrl)
                        )})`,
                      }}
                      className={classnames({
                        [styles.itemImg]: true,
                      })}
                    >
                      {/* <div
                          style={{
                            backgroundImage: `url(${src(item.picHoverUrl)})`,
                          }}
                          className={classnames({
                            [styles.itemHover]: true,
                            [styles.active]: index === active,
                          })}
                        /> */}
                    </div>
                    <div className={styles.itemWrapper}>
                      <div className={styles.itemTitle}>{item.title}</div>
                      <div className={styles.itemContent}>{item.content}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Element>
    );
  } else {
    return <ScenarioMultiRow {...{ scenarios, bgColor }}></ScenarioMultiRow>;
  }
};

export default Scenario;
